export class AddRoleModel {
    Name: string;
    Description: string;
    CreatedBy: string;
    isActive: boolean;
    rolePermissions: any[] = [];
    databaseID: number;
    organizationID: number;
    officeID:number=0;
}
